import { X } from 'lucide-react';

const XeroInvoicePdfModal = ({ open, onClose, title, pdfUrl, loading, error }) => {
    if (!open) return null;

    return (
        <div className="mobile-dialog-shell fixed inset-0 !top-0 !mt-0 z-[99999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="w-full max-w-5xl h-[88vh] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
                <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
                    <div>
                        <h2 className="text-sm font-black text-zinc-800">
                            {title || 'Xero Invoice'}
                        </h2>
                        <p className="text-xs text-gray-400">
                            PDF preview from Xero
                        </p>
                    </div>

                    <button
                        type="button"
                        onClick={onClose}
                        className="w-9 h-9 rounded-xl bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-zinc-700"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                <div className="flex-1 bg-gray-100">
                    {loading && (
                        <div className="h-full flex items-center justify-center text-sm font-semibold text-gray-500">
                            Loading invoice PDF...
                        </div>
                    )}

                    {error && !loading && (
                        <div className="h-full flex items-center justify-center text-sm font-semibold text-red-600 px-6 text-center">
                            {error}
                        </div>
                    )}

                    {!loading && !error && pdfUrl && (
                        <iframe
                            src={pdfUrl}
                            title="Xero Invoice PDF"
                            className="w-full h-full border-0"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default XeroInvoicePdfModal;